import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaRegBell } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import classes from "./Navbar.module.css";
const Navbar = () => {
  const navigate = useNavigate();
  const { meData, isLogin, allCategoryData } = useSelector(
    (state) => state?.commonReducer
  );
  const { unReadCount, unReadMessageCount } = useSelector(
    (state) => state?.notificationReducer
  );
  const [tabsText, setTabsText] = useState("");
  const [primarySubCategory, setPrimarySubCategory] = useState("");
  const [lastCategory, setLastCategory] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setTabsText("");
  };

  return (
    <>
      <style>
        {`
      .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper{
         width:40%;
         height:auto;
        margin-top:10px;
        background-color:#fff;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      }
      .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper li:hover{
        background-color:#fff !important;
      }
      .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper:hover{
        background-color:#fff !important;
      }
      .MuiTouchRipple-root{
        display:none;
      }
      `}
      </style>
      <div className="navbar">
        <div className="container">
          <div className="navbar-item">
            <div>
              <div className={classes.category__lists}>
                {allCategoryData?.map((ele) => {
                  return (
                    <>
                      <Button
                        className={classes.btnText}
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                      >
                        <p
                          style={
                            ele?.name === tabsText
                              ? {
                                  // borderBottom: "2px solid var(--main-color)",
                                  // paddingBottom: "2px",
                                  textDecoration: "underline",
                                  textDecorationColor: "var(--main-color)",
                                  textDecorationThickness: "3px",
                                  textUnderlineOffset: "20px",
                                }
                              : {}
                          }
                          onClick={() => {
                            setTabsText(ele?.name);
                            setPrimarySubCategory(
                              allCategoryData?.find(
                                (category) => category?._id === ele?._id
                              )?.children[0]?._id
                            );
                          }}
                        >
                          {ele?.name}
                        </p>
                      </Button>
                      {ele?.name === tabsText && (
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem>
                            <div className={classes.popper}>
                              <Row>
                                <Col
                                  className={classes.primary__main__col}
                                  lg={4}
                                >
                                  <div className={classes.primary__main}>
                                    <p
                                      onClick={() => {
                                        navigate(`/products/${ele._id}`);
                                        handleClose();
                                      }}
                                    >
                                      All
                                    </p>
                                    {ele?.children?.map((item) => {
                                      return (
                                        <p
                                          style={
                                            item?._id === primarySubCategory
                                              ? { fontWeight: "600" }
                                              : {}
                                          }
                                          onClick={() => {
                                            setPrimarySubCategory(item?._id);
                                          }}
                                        >
                                          {item?.name}
                                        </p>
                                      );
                                    })}
                                  </div>
                                </Col>
                                <Col lg={8}>
                                  <Row>
                                    {ele?.children
                                      ?.find(
                                        (e) => e?._id === primarySubCategory
                                      )
                                      ?.children?.map((element) => {
                                        return (
                                          <Col md={6}>
                                            <p
                                              onClick={() => {
                                                setLastCategory(element);
                                                navigate(
                                                  `/products/${element._id}`
                                                );
                                                handleClose();
                                              }}
                                              className={
                                                classes.secondarySubCategoryText
                                              }
                                            >
                                              {element?.name}
                                            </p>
                                          </Col>
                                        );
                                      })}
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          </MenuItem>
                        </Menu>
                      )}
                    </>
                  );
                })}
              </div>

              <div>
                <div
                  className="notification__count"
                  onClick={() => navigate("/messages")}
                >
                  {unReadMessageCount > 0 && <span>{unReadMessageCount}</span>}
                  <img src="/images/messageIcon.png" alt="messageIcon.png" />
                </div>
                <div onClick={() => navigate("/favourite")}>
                  <img src="/images/heartIcon.png" alt="heartIcon.png" />
                </div>
                {isLogin && (
                  <div
                    className="notification__count"
                    onClick={() =>
                      navigate(
                        meData?.role === "user"
                          ? "/notification"
                          : "/admin/notification"
                      )
                    }
                  >
                    {unReadCount > 0 && <span>{unReadCount}</span>}
                    <FaRegBell size={23} />
                  </div>
                )}
              </div>
            </div>
            <div>
              <button
                onClick={() => navigate(isLogin ? "/sell-item" : "/login")}
              >
                SELL NOW
              </button>
              <div>
                <img src="/images/smartphone.png" alt="smartphone.png" />
                <Link to={"/"}>Download Our App</Link>
                <img src="/images/arrowDownIcon.png" alt="arrowDownIcon.png" />
              </div>
              <Link to={"/about"}>About us</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
